export default {
  general: 'General',
  materialCalculationModels: 'Material Calculation Models',
  quenchingMediaSettings: 'Quenching media',
};
